// extracted by mini-css-extract-plugin
module.exports = {"partner":"Index_partner_2Q9rW","content":"Index_content_1ZTt6","today":"Index_today_3Z9yv","form":"Index_form_3ZTaO","input":"Index_input_1mrRi"};